module.exports = __webpack_public_path__ + "img/cmp_edge.7d75b7b4.png";